import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export interface leadgroup {
    id: number;
    listgroup_name: string;
}

export interface HTTPGrouplist {
    listgroup_name: string;
    id:number
}

export class laedgroupForm implements HTTPGrouplist {
    public listgroup_name: string;
    public id:number
    constructor(data: leadgroup) {
        if (data == null) {
            this.listgroup_name = "";
        }
        else {
            this.id=data.id
            this.listgroup_name = data.listgroup_name;
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            listgroup_name: [this.listgroup_name,  [Validators.required]],
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.listgroup_name = fg.get("listgroup_name").value;
            return true;
        }
        else {
            return false;
        }
    }
}
